module.exports = __webpack_public_path__ + "img/img-1.c29bf904.png";